import { render, staticRenderFns } from "./LearningProfileCard.vue?vue&type=template&id=4df40bf3&scoped=true&"
import script from "./LearningProfileCard.vue?vue&type=script&lang=js&"
export * from "./LearningProfileCard.vue?vue&type=script&lang=js&"
import style0 from "./LearningProfileCard.vue?vue&type=style&index=0&id=4df40bf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df40bf3",
  null
  
)

export default component.exports